// Ledger outcomes (step 4a), in the order the page lists them: what every
// moment the selector found ended as.
export const MOMENT_OUTCOMES = [
  {
    key: 'cut',
    label: 'cut',
    color: 'success',
    help: 'Admitted by the duel and stored as a moment.',
  },
  {
    key: 'refused',
    label: 'refused',
    color: 'default',
    help: 'Well-formed, and did not beat 2 of the 7 typical posts it faced.',
  },
  {
    key: 'overlap',
    label: 'overlap',
    color: 'default',
    help: 'A stored moment already covers this audio; fenced before the duel.',
  },
  {
    key: 'unquotable',
    label: 'unquotable',
    color: 'warning',
    help: 'The model’s quote is not a verbatim excerpt of the words under it, or is a whole long turn.',
  },
  {
    key: 'unplayable',
    label: 'unplayable',
    color: 'warning',
    help: 'A timestamp fell outside the cut, or the moment ran past the turn or word bound; the contract refused it.',
  },
  {
    key: 'unjudged',
    label: 'unjudged',
    color: 'warning',
    help: 'The judge answered nothing twice (a safety block, an empty or garbled reply). Never admitted; the trace names why.',
  },
  {
    key: 'no_turns',
    label: 'no turns',
    color: 'warning',
    help: 'The window resolved to no speech words.',
  },
  {
    key: 'capped',
    label: 'capped',
    color: 'default',
    help: 'Past the per-span cap; never duelled. The cap ships off.',
  },
  {
    key: 'owed',
    label: 'owed',
    color: 'info',
    help: 'Not answered yet: a deferred or throttled pass will answer it.',
  },
]

// A span's cost rows (the API's `span_cost`), in the proto's words: the task
// and what it is billed in.
export const TASK_WORDS = {
  transcribe: 'transcribe',
  selector: 'find moments',
  judge: 'judge the bar',
}

export const BILLED_WORDS = {
  audio_seconds: 'audio seconds',
  prompt_tokens: 'input tokens',
  output_tokens: 'output tokens',
  thinking_tokens: 'thinking tokens',
}

// The last selection pass's stages (the trace's `this_pass.timings`). A
// `moment:N` stage is the ledger's row N; `cut` runs inside the moments.
export const STAGE_WORDS = {
  fetch: 'fetch audio',
  fold: 'fold into bouts',
  select: 'find moments',
  cut: 'cut audio (within moments)',
}
